import { MenuItem, SelectableMenuItem } from '@/models';
import { isDefined } from '@/helpers/util';

export type ItemReferencingMenuItem = MenuItem & { pricingReferenceItemId?: string | null };

export function findReferencingMenuItems<TItem extends ItemReferencingMenuItem>(referencingItems: TItem[], itemId: string): TItem[] {
  return referencingItems.filter(i => i.pricingReferenceItemId == itemId);
}

export function findItemsReferencing<TItem extends ItemReferencingMenuItem>(referencingItems: SelectableMenuItem<TItem>[], itemId: string): SelectableMenuItem<TItem>[] {
  return referencingItems.filter(i => i.item.pricingReferenceItemId == itemId);
}

export function findItemReferencing<TItem extends ItemReferencingMenuItem>(
  referencingItems: SelectableMenuItem<TItem>[],
  itemId: string,
): SelectableMenuItem<TItem> | undefined {
  return findItemsReferencing(referencingItems, itemId)[0];
}

export function findReferencedItems<TItem extends SelectableMenuItem>(referencingItems: SelectableMenuItem[], items: TItem[]): TItem[] {
  return referencingItems.map(r => items.find(i => r.item.pricingReferenceItemId == i.item.itemId || i.item.itemId == r.item.itemId)).filter(isDefined);
}
